import { RichText } from "../../common/cms/RichText/RichText";
import { FullWidthContainer } from "../../common/components/layout/Container";
import { ContainerLoader } from "../../common/components/loaders/ContainerLoader";
import BackButtonInContainer from "../../common/components/ui/buttons/BackButtonInContainer";
import { locationSelectors } from "../../common/store/slice/locationSlice";
import { usePrivacyPolicyForCurrentCountry } from "../../firebase/db/privacyPolicy";
import { parseLanguageCode } from "../../i18n/utils";
import { StaticTranslations } from "@pslifestyle/common/src/schemas";
import { useSelector } from "react-redux";

const PrivacyNoticePage = (): JSX.Element => {
  const language = useSelector(locationSelectors.language);
  const { languageCode } = parseLanguageCode(language);
  const { data, isLoading } = usePrivacyPolicyForCurrentCountry();
  const [, privacyPolicies] =
    (data as [string, StaticTranslations["privacyPolicy"]]) ?? [];

  return (
    <>
      <BackButtonInContainer />
      <FullWidthContainer>
        <ContainerLoader loading={isLoading}>
          <RichText
            content={privacyPolicies?.privacyPolicy}
            localizedContent={privacyPolicies?.localizedPrivacyPolicy}
            languageCode={languageCode}
          />
        </ContainerLoader>
      </FullWidthContainer>
    </>
  );
};
export default PrivacyNoticePage;
